import React, {useEffect, useRef, useState} from 'react';
import cl from '../BaseSimplePage/BaseSimpleItemBrowser.module.css'
import {Alert, LinearProgress} from "@mui/material";
import ServerManager from "../../API/ServerManager";
import SubscriptionCancellationsSummaryBrowserHeader from "./SubscriptionCancellationsSummaryBrowserHeader";

const TYPING_TIMEOUT = 500; // [ms]

const SubscriptionCancellationsSummaryBrowser = ({
                                     setSummaryData,
                                 }) => {

    const [totalItemCount, setTotalItemCount] = useState(-1);
    const [dateFromText, setDateFromText] = useState('');
    const [dateTillText, setDateTillText] = useState('');

    //----

    const rqIdCounter = useRef(0);
    const [status, setStatus] = useState(""); // "", idle, mainLoad, addLoad, mainError, typing
    const [mainErrorMessage, setMainErrorMessage] = useState("");
    const [lastTypingTime, setLastTypingTime] = useState(0);
    const [refreshCounter, setRefreshCounter] = useState(0);


    // for call
    function onFilterEdit(forceUpdate = false) {
        setStatus("typing");
        setLastTypingTime(forceUpdate ? 0 : Date.now());
        setSummaryData(null);
        setTotalItemCount(-1);
        rqIdCounter.current++;
    }

    // после первого рендера сразу запрашиваем первую порцию
    useEffect(() => {
        requestMainItems();

        // при анмоунте отменяем текущий запрос
        return () => {
            rqIdCounter.current++;
        }
    }, []);

    // for refresh
    useEffect(() => {
        if (refreshCounter > 0)
            requestMainItems();
    }, [refreshCounter]);


    async function requestMainItems() {

        if (dateFromText === "error" || dateTillText === "error")
        {
            setStatus("idle");
            return;
        }

        const extraParams = {};

        if (dateFromText)
            extraParams.from = dateFromText;

        if (dateTillText)
            extraParams.to = dateTillText;

        rqIdCounter.current++;
        const rqId = rqIdCounter.current;
        //console.log("rqId", rqId);

        setStatus("mainLoad")
        try {
            //await new Promise(resolve => setTimeout(resolve, 3500)); // temp!
            const data = await ServerManager.getSubscriptionCancellationsAggregation(extraParams);
            if (rqIdCounter.current === rqId) {
                setSummaryData(data);
                setTotalItemCount(data.total);
                setStatus("idle");
            }
        } catch (error) {
            if (rqIdCounter.current === rqId) {
                setMainErrorMessage(`Ошибка при загрузке данных: ${error}`);
                setStatus("mainError");
            }
        } finally {
            if (rqIdCounter.current !== rqId) {
                //console.log("ignored! rqId", rqId);
            }
        }
    }

    // запуск/продление временной задержки во время ввода текста
    useEffect(() => {
        async function wait() {
            const leftTime = lastTypingTime + TYPING_TIMEOUT - Date.now();
            if (leftTime > 0)
                await new Promise(resolve => setTimeout(resolve, leftTime));
            if (!ignore)
                requestMainItems();
        }

        if (status !== "typing")
            return;

        let ignore = false;
        wait();
        return () => {
            ignore = true;
        }

    }, [status, lastTypingTime]);

    return (<div className={cl.main}>
        <SubscriptionCancellationsSummaryBrowserHeader
            totalItemCount={totalItemCount}
            onFilterEdit={onFilterEdit}
            dateFromText={dateFromText}
            setDateFromText={setDateFromText}
            dateTillText={dateTillText}
            setDateTillText={setDateTillText}
        />
        {(status === "mainLoad" || status === "typing") && <LinearProgress/>}
        {status === "mainError" && <Alert variant="outlined" severity="error">{mainErrorMessage}</Alert>}
    </div>);
};

export default SubscriptionCancellationsSummaryBrowser;